export default {
    topics: [
        {
            title: ' DBEngine (Class) ',
            href: 'c-DBEngine.html',
            attributes: { 'data-id': 'c-DBEngine' },
            menu: { hasChildren: false },
            tocID: 'c-DBEngine-d66e5643',
            next: 'c-DBEngine-d66e5643',
        },
    ],
};

